// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"c7c80ccb","677":"27e597b6","706":"005f46f1","787":"268d262f","902":"3dd8e26e","927":"f9c23da4","954":"0998a279"}[chunkId] + ".chunk.js";
};